export default __webpack_public_path__ + "1dfee1319a7a003e2e7a67588f428f29.svg";